import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import NotepadIcon from 'components/atoms/icons/notepadIcon';
import { getLanguageLabelById } from 'utils';

const ActivityRow = ({ activity }) => {
  const adherenceStyle = (adherence) => {
    const value = Math.round(adherence * 100);
    if (value < 36) return 'rangeRed';
    if (value < 66) return 'rangeYellow';
    return 'rangeLightGreen';
  };

  const patientLanguage = () => {
    const language = getLanguageLabelById(activity.patient.language) || '';

    return language;
  };

  const copyTextToClipboard = (item) => {
    navigator.clipboard.writeText(item);
  };

  const deviceIds = activity.devices?.ids.join(', ');
  const deviceBrands = activity.devices?.manufacturers.join(', ');

  return (
    <tr className="activity-row">
      <td data-label="Patient Name">
        <Link to={`/patient/${activity.patient.guid}`}>
          <strong>
            {activity.patient.firstName} {activity.patient.lastName}
          </strong>
        </Link>
      </td>
      <td data-label="MRN">{activity.patient.mrn}</td>
      <td data-label="DOB" className="date-of-birth">
        {activity.patient.birthDate}
      </td>
      <td data-label="Insurance Plan Provider">
        {activity.insurance?.provider}
      </td>
      <td data-label="Insurance Plan Number">{activity.insurance?.number}</td>
      <td data-label="Language">{patientLanguage()}</td>
      <td data-label="Physician">
        {activity.doctor?.title} {activity.doctor?.firstName}{' '}
        {activity.doctor?.lastName}
      </td>
      <td data-label="Phone Number">{activity.patient.phone}</td>
      <td data-label="Secondary Phone Number">{activity.patient.homeNumber}</td>
      <td className="activity-row__email" data-label="Email">
        {activity.patient.email}
      </td>
      <td data-label="Prefer Contact Method">
        {activity.patient.preferredContactMethod}
      </td>
      <td data-label="Devices ID" className="device-id">
        <div className="device-id-cell-content">
          <div className="cut-text-adherence">{deviceIds}</div>
          <button
            className="notepadbtn"
            onClick={() => copyTextToClipboard(activity.devices.ids.join(', '))}
          >
            {deviceIds && <NotepadIcon />}
          </button>
        </div>
      </td>
      <td data-label="Devices Brand">{deviceBrands}</td>
      <td data-label="Adherence" className={adherenceStyle(activity.adherence)}>
        {Math.round(activity.adherence * 100)}%
      </td>
      <td data-label="Last Reading">{activity.lastReading ?? ''}</td>
    </tr>
  );
};

ActivityRow.propTypes = {
  activity: PropTypes.shape().isRequired,
};

export default ActivityRow;
